import { startCase, toLower } from 'lodash'
import React, { FC, useState } from 'react'
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css'
import { Document, Page, pdfjs } from 'react-pdf'
import { MOBILE_THRESHOLD } from '../../../styles/theme'
import { useWindowSize } from '../../../utils/useWindowSize'
import { AbstractEmail } from '../AbstractEmail'
import { AbstractRating } from '../AbstractRating'
import { AbstractType } from '../PresentationContainer/PresentationContainer'
import { PosterPresentionStyle } from './styled'
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

interface PosterPresentationProps {
  hasRated: boolean
  abstract: AbstractType
}

export const PosterPresentation: FC<PosterPresentationProps> = ({ hasRated, abstract }) => {
  const [pdfPages, setPdfPages] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const { windowWidth } = useWindowSize()

  const pdfWidth = windowWidth <= MOBILE_THRESHOLD ? windowWidth : 744

  return (
    <>
      <PosterPresentionStyle>
        <div id="pdfContainer">
          {abstract.audio_recording?.url && (
            <AudioPlayer
              autoPlay
              src={abstract.audio_recording?.url}
              customAdditionalControls={[]}
              customVolumeControls={[]}
              style={{
                width: '100%',
                maxWidth: pdfWidth,
              }}
            />
          )}
          {abstract.poster && (
            <Document
              file={abstract.poster?.url}
              loading={<p className="text-center text-white mt-3">Loading ePoster...</p>}
              onLoadSuccess={({ numPages }) => {
                setPdfPages(numPages)
              }}
            >
              <Page width={pdfWidth} pageNumber={currentPage} />
            </Document>
          )}
        </div>
        {typeof pdfPages === 'number' && pdfPages > 1 && (
          <div className="pdfPageSelector">
            {Array.from({ length: pdfPages }).map((_, index) => (
              <button
                onClick={() => {
                  setCurrentPage(index + 1)
                }}
              >
                {index + 1}
              </button>
            ))}
          </div>
        )}
        <section id="bottomSection">
          <div>
            <p className="text-muted mb-2">{abstract.area_of_interest}</p>
            <h4 className="abstractTitle">{abstract.title}</h4>
            <p className="authorName">{startCase(toLower(abstract.presenting_author_name))}</p>
          </div>
          <div className="interactionSection">
            <AbstractEmail email={abstract.presenter_email} />
            <AbstractRating abstractId={abstract.id} defaultRated={hasRated} />
          </div>
        </section>
      </PosterPresentionStyle>
    </>
  )
}
